import ButtonNavigation from "./ButtonNavigation";
import Header from "./Header";
import NoFollow from "./NoFollow";
import Splash from "./Splash";

export default {
  ButtonNavigation,
  Header,
  Splash,
  NoFollow
};
